import { TableMap } from '../table-map';
import { findTable } from './find';
import { getSelectionRect } from './get-selection-rect';
export function getSelectedTableInfo(selection) {
  var map;
  var totalRowCount = 0;
  var totalColumnCount = 0;
  var table = findTable(selection);
  if (table) {
    map = TableMap.get(table.node);
    totalRowCount = map.height;
    totalColumnCount = map.width;
  }
  return {
    table: table,
    map: map,
    totalRowCount: totalRowCount,
    totalColumnCount: totalColumnCount
  };
}
export function getSelectedCellInfo(selection) {
  var horizontalCells = 1;
  var verticalCells = 1;
  var totalCells = 1;
  var _getSelectedTableInfo = getSelectedTableInfo(selection),
    table = _getSelectedTableInfo.table,
    map = _getSelectedTableInfo.map,
    totalRowCount = _getSelectedTableInfo.totalRowCount,
    totalColumnCount = _getSelectedTableInfo.totalColumnCount;
  if (table && map) {
    var rect = getSelectionRect(selection);
    if (rect) {
      totalCells = map.cellsInRect(rect).length;
      horizontalCells = rect.right - rect.left;
      verticalCells = rect.bottom - rect.top;
    }
  }
  return {
    totalRowCount: totalRowCount,
    totalColumnCount: totalColumnCount,
    horizontalCells: horizontalCells,
    verticalCells: verticalCells,
    totalCells: totalCells
  };
}